import _sfc_main from './voice-content.vue.js';
/* empty css                   */
import _export_sfc from '../../../_virtual/_plugin-vue_export-helper.js';

const VoiceContent = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-384c7425"]]);

export { VoiceContent as default };
//# sourceMappingURL=voice-content.js.map
